<div class="container-fluid individual-active-test">
  <!-- 全画面のモーダル -->
  <full-modal id="individual-at-modal" :contentId="modalContentId()" :showModal="showModal" />

  <!-- vue3.5以降でないとdeferが使用できないため、移動先の描画完了までteleport自体を描画しない -->
  <wrapped-teleport :destinationId="graphSettingsDestinationId()" :noRenderTeleport="!measureMounted"
    :disabled="!showModal">

    <!-- メモボタン -->
    <div v-if="!noSignalItems" v-show="!showDmSelect && !showAtSelect" class="one-liner-btns">
      <div class="left-side-btn">
        <b-button :class="showModal ? '' : 'mt-n5 ml-n4'" variant="primary" size="sm" @click="openMemo"
          :disabled="btnDisabled.memo">
          {{ $t('message.button_vehicle_dtc_note_modal') }}
        </b-button>
        <b-button :class="showModal ? 'ml-1' : 'mt-n5 ml-2'" variant="primary" size="sm" :disabled="btnDisabled.export"
          @click="csvExport">
          {{ $t('message.file_export') }}
        </b-button>
      </div>
      <div class="right-side-btn">
        <!-- グラフ設定ボタン -->
        <no-text-svg-button :class="showModal ? BUTTON_TYPE.RIGHT_TOP : `mt-n5 ${BUTTON_TYPE.RIGHT_TOP}`"
          variant="outline-info" :iconKey="ICON_KEY.CONFIG" @click="handleConfigureGraph" :disabled="btnDisabled.graph"
          :title="$t('individual.button_data_monitor_graph_config')" />

        <!-- ズームリセットボタン -->
        <no-text-svg-button :disabled="btnDisabled.resetZoom"
          :class="showModal ? BUTTON_TYPE.RIGHT_TOP : `mt-n5 ${BUTTON_TYPE.RIGHT_TOP}`" variant="outline-info"
          :iconKey="ICON_KEY.RESET_ZOOM" @click="handleResetZoom($event)"
          :title="$t('individual.label_data_monitor_reset_zoom')" />

        <!-- 最大化ボタン -->
        <no-text-svg-button v-if="!showModal" :class="`mt-n5 ${BUTTON_TYPE.RIGHT_TOP}`" variant="outline-info"
          :iconKey="ICON_KEY.MAXIMUM" @click="maximum()"
          :title="$t('individual.label_data_monitor_hint_maximize_action')" />
        <!-- 最小化ボタン -->
        <no-text-svg-button v-else :class="BUTTON_TYPE.RIGHT_TOP" variant="outline-info" :iconKey="ICON_KEY.MINIMUM"
          @click="minimum()" :title="$t('individual.label_data_monitor_hint_minimize_action')" />
      </div>
    </div>

    <!-- 信号線未選択時は、最大化・最小化ボタンのみ表示する -->
    <div v-else v-show="!showDmSelect && !showAtSelect" class="one-liner-btns">
      <div class="right-side-btn" style="margin-left: auto;">
        <!-- 最大化ボタン -->
        <no-text-svg-button v-if="!showModal" :class="`mt-n5 ${BUTTON_TYPE.RIGHT_TOP}`" variant="outline-info"
          :iconKey="ICON_KEY.MAXIMUM" @click="maximum()"
          :title="$t('individual.label_data_monitor_hint_maximize_action')" />
        <!-- 最小化ボタン -->
        <no-text-svg-button v-else :class="BUTTON_TYPE.RIGHT_TOP" variant="outline-info" :iconKey="ICON_KEY.MINIMUM"
          @click="minimum()" :title="$t('individual.label_data_monitor_hint_minimize_action')" />
      </div>
    </div>
  </wrapped-teleport>

  <!-- アクティブテスト項目選択 -->
  <div v-show="showAtSelect" class="at-select row">
    <div class="text-left col-6">
      <b-form autocomplete="off">
        <b-form-input v-model="filterText" type="text" class="w-100 mt-4" size="sm" autocomplete="off"
          :placeholder="$t('individual.label_active_test_filter')" @input="updateFilter" />
      </b-form>
      <cstm-table useStripeStyle rowSelect usePopup useSort hasTabs class="support-table-at mt-2" type="simple"
        ref="filtered_tbl" :currentSortkey="currentSortkey" :items="escapeFunctionList(filteredFunctionList)"
        :columns="columns" @rowClicked="clickRow">
      </cstm-table>
    </div>
    <div class="text-left col-6">
      <b-form-group>
        <label style="font-weight: bold;" class="label-sm mt-4">{{ $t('individual.common_label_description') }}</label>
        <b-form-textarea type="text" class="mt-3" style="background-color: white;" no-resize size="sm" rows="12"
          readonly tabindex="-1" :placeholder="$t('individual.common_label_description')"
          :value="selectedActiveTest ? selectedActiveTest.menu_description : ''">
        </b-form-textarea>
        <div class="text-right w-100">
          <b-button size="sm" class="mt-2" variant="primary" @click="selectAtFunc()">
            {{ $t('individual.button_active_test_select') }}
          </b-button>
        </div>
      </b-form-group>
    </div>
  </div>

  <div v-show="!showAtSelect" class="contents-area">
    <teleport :to="`#${modalContentId()}`" :disabled="!modalContentId() || !showModal">
      <!-- コントロールパネル API実行順のためv-show -->
      <control-panel v-show="!showDmSelect" class="control-panel" ref="control_panel" :selectedAtFunc="selectedAtFunc"
        :i18nMenuTitleKey="i18nMenuTitleKey" :isDriving="isDriving" :inExecution="inExecution"
        :showDmSelect="showDmSelect" :baseTime="baseTime" :isDmError="isDmError" @toggle-drive="toggleDrive" @toggle-execute="toggleExecute"
        @toggle-read-executed="toggleReadExecuted" @err-terminate="errTerminate" @at-failure="atFailure"
        @dm-change-to-blank="dmChangeToBlank" @save-active-test-executeMark="saveActiveTestExecuteMark"
        @notify-change-drive="notifyChangeDrive" @stop-monitor="stopMonitor" />
    </teleport>

    <!-- データモニタ -->
    <data-monitor v-if="!showAtSelect" ref="data_monitor" :parentName="parentName" :measureId="measureId"
      :showSelect="showDmSelect" :inExecution="inExecution" :inPlaying="inPlaying" :isUseCache="isUseCache"
      :highlightItems="highlightItems" :dataMonitorFunctionSettings="dataMonitorFunctionSettings"
      :selectedActiveTestId="activeTestId" :selectedAtFunc="selectedAtFunc" :isActiveTestDriving="isDriving"
      :showModal="showModal" :modalContentId="modalContentId()"
      :graphSettingsDestinationId="graphSettingsDestinationId()" :isSpecial="isSpecial" :isOnlyCsvExport=false
      @toggle-show-select="toggleShowDmSelect" @toggle-execute="toggleExecute" @toggle-playing="togglePlaying"
      @change-measure-id="setMeasuredId" @back-select="backMeasure" @exec-stop-monitor="stopMonitor"
      @change-check-value="changeCheckValue" @current-tab-changed="currentTabChanged"
      @zoom-pan-state-changed="zoomPanStateChanged" @change-no-signal="changeNoSignal" @dm-err-notify="dmErrorHandling"
      @base-time-changed="changeBaseTime" @maximum="maximum" @minimum="minimum"
      @measure-mounted="measureMountedEvent" />
  </div>

  <!-- 選択の画面下部ボタン -->
  <div v-if="!showAtSelect && showDmSelect" class="bottom-btns">
    <b-button variant="outline-primary" size="sm" @click="backSelect">
      {{ $t("message.common_button_back") }}
    </b-button>
  </div>

  <!-- メモ画面 -->
  <b-modal v-model="modalMemo" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_note_modal') }}
      </div>
    </template>

    <memo-page v-if="modalMemo" ref="memo" :projectId="projectId" :measureId="measureId" :functionNameKey="navItemLabel"
      :destinationAPI="destinationAPI" :modalLoading="isMemoDialogLoading" @closeNoteModal="closeNoteModal"
      @update-loading="isMemoDialogLoading = $event" />

    <template v-slot:footer>
      <button type="button" :disabled="isMemoDialogLoading" v-on:click="memoClear()"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">
        {{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="outline-primary" @click="modalMemo = false"
          class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="primary" @click="memoSave()" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- CSVエクスポート時のプログレスバー -->
  <b-modal v-model="showCsvProgress" id="dm-play-export-csv-progress" size="lg" header-bg-variant="secondary"
    header-text-variant="light" no-stacking no-close-on-backdrop no-close-on-esc centered hide-footer>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('individual.data_monitor_csv_export_progress_title') }}
      </div>
    </template>

    <template v-slot:default>
      <div class="container-fluid mt-2 mb-2">
        <custom-progress :value="exportPercentage" :message="$t('individual.data_monitor_csv_export_progress_message')" />
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>